import React from 'react';
import { PROFILE } from '../data/profile';
import Icon from './Icons';

export default function Hero() {
  const [first, ...rest] = PROFILE.name.split(' ');
  return (
    <section id="hero" className="hero" data-section>
      <div className="container hero__inner">
        <div className="hero__text">
          <span className="hero__greeting">{PROFILE.status}</span>
          <h1 className="hero__name">{first} <em>{rest.join(' ')}</em></h1>
          <p className="hero__tagline">{PROFILE.tagline}</p>
          <p className="hero__bio">{PROFILE.bio}</p>
          <div className="hero__actions">
            <a href={`mailto:${PROFILE.email}`} className="btn btn--primary"><Icon name="mail" /> Get in touch</a>
            <a href={PROFILE.githubUrl} target="_blank" rel="noopener noreferrer" className="btn btn--ghost"><Icon name="github" /> GitHub</a>
            <a href={PROFILE.linkedinUrl} target="_blank" rel="noopener noreferrer" className="btn btn--ghost"><Icon name="linkedin" /> LinkedIn</a>
            <a href={PROFILE.resumeUrl} target="_blank" rel="noopener noreferrer" className="btn btn--ghost">Resume ↗</a>
          </div>
        </div>
        <div className="hero__photo">
          <div className="hero__photo-wrapper">
            <img src={PROFILE.photo} alt={PROFILE.name} />
            <div className="hero__badge"><b>{PROFILE.location}</b></div>
          </div>
        </div>
      </div>
    </section>
  );
}
